import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { SessionService } from '@monsido/ng2/core/session/session.service';
import { BaseRepo } from '@client/app/services/api/base-repo/base-repo';
import { CreateExport, CreateExportResponse } from '../types/create-export.type';

@Injectable({
    providedIn: 'root',
})
export class CreateExportRepoService extends BaseRepo {
    constructor (
        private apiService: ApiService,
        protected sessionService: SessionService,
    ) {
        super();
    }

    createExport (
        payload: CreateExport['payload'],
    ): Promise<CreateExportResponse> {
        return this.apiService.post('exports', payload);
    }
}
